import { ChipDelimiter, FormChipInput } from "@redotech/redo-web/chip-input";
import * as gridCss from "@redotech/redo-web/grid.module.css";
import { Input, input } from "@redotech/ui/form";
import { arrayEqual, stringEqual } from "@redotech/util/equal";
import { memo } from "react";

export const additionalCoverageWebSourcesForm = input<readonly string[]>({
  equal: arrayEqual(stringEqual),
});

export const additionalCoverageWebSourcesDefault: string[] = [];

export const AdditionalCoverageWebSourcesSettings = memo(
  function AdditionalCoverageWebSourcesSettings({
    input,
  }: {
    input: Input<readonly string[]>;
  }) {
    return (
      <section className={gridCss.grid}>
        <div className={gridCss.span12}>
          <FormChipInput
            delimiter={ChipDelimiter.NEWLINE}
            description="Custom source names that should be treated as web orders for coverage monitoring. These will be used in addition to the default 'web' source. Enter one source name per line."
            input={input}
            label="Additional web source names"
            placeholderText="e.g., mobile-app, pos, kiosk"
            trimWhitespace
          />
        </div>
      </section>
    );
  },
);
